export class StartSparkJobTemplateParams {
    'jobTemplateId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobTemplateId",
            "baseName": "jobTemplateId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return StartSparkJobTemplateParams.attributeTypeMap;
    }
    constructor() {
    }
}
